/*
 * @Author       : 程哲林
 * @Date         : 2022-01-14 15:48:48
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-03-21 14:15:42
 * @FilePath     : /marketing-introduce-ssr/services/index.ts
 * @Description  : 未添加文件描述
 */

import session from '@woulsl/storage/session';
import { rq } from 'utils/request';

import { RECORD_KEY, TINMAN_BASE_C_URL } from '../common/const';

export async function getWxConfig<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: '/api/product/open/wxmp/create-signature',
    prefix: '/mall/product',
    baseURL: TINMAN_BASE_C_URL,
    params
  });
}

export async function userActionRecord(params = {}, isOpen = false) {
  try {
    const data = session.get(RECORD_KEY);

    if (!data) {
      session.set(RECORD_KEY, params);
    }

    await rq({
      url: 'action/userActionRecord',
      method: 'POST',
      authPlatform: isOpen ? [] : ['jojoApp', 'miniApp', 'wx'],
      authPrefix: '/fe/',
      prefix: '/open/',
      data: {
        ...data,
        sceneType: __store?.actInfo?.activityType,
        ...params
      },
      baseURL: `${TINMAN_BASE_C_URL}/api/gravity`,
      // 该接口不做登录拦截
      enforcement: true
    });
  } catch (e) {
    console.error(e);
  }
}

export async function getRetainRule<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'activity/getRetainPopup',
    authPlatform: ['jojoApp', 'miniApp', 'wx'],
    authPrefix: '/fe/',
    prefix: '/open/',
    params
  });
}

export async function scanCodeSaveOpenId<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'event/scanCodeSaveOpenId',
    prefix: '/open/',
    data: params,
    method: 'POST'
  });
}
export async function scanActivityCode<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'event/scanActivityCode',
    prefix: '/fe/',
    data: params,
    method: 'POST'
  });
}

export async function getWxSchemaUrl<T>(params?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url: 'wechatMiniProgram/getSchemaUrl',
    data: params,
    prefix: '/mall/cashback/noRight/',
    baseURL: TINMAN_BASE_C_URL,
    method: 'POST'
  });
}
